<template>
  <div class="team-search-bar" @click.stop="handleShowSearch">
    <!-- Mobile Search -->
    <div v-if="$root.isMobile" class="team-search-bar__mobile">
      <div class="team-search-bar__text">
        {{ localSearch || 'Начать поиск команды' }}
      </div>
      <div class="team-search-bar__icon">
        <Icon name="search" size="s" />
      </div>
    </div>

    <!-- Desktop Search -->
    <div v-if="!$root.isMobile" class="team-search-bar__desktop">
      <div class="team-search-bar__field">
        <div class="team-search-bar__label">Название</div>
        <div class="team-search-bar__input">
          <Input
            :value="localSearch"
            placeholder="Как называется команда?"
            id="team-search"
            noBorder
            :disabled="loading"
            @input="updateSearch"
            @keydown="handleSearchKeydown"
          />
        </div>
      </div>
      <div class="team-search-bar__action">
        <Button
          variant="primary"
          size="lg"
          text="Найти"
          iconLeft="search"
          @click="$emit('search')"
          :disabled="loading"
          :loading="searchLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@rr-component-library/input/src/main';
import Button from '@rr-component-library/button/src/main';

export default {
  name: 'TeamSearchBar',
  components: {
    Input,
    Button,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSearch: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localSearch = newVal;
    },
  },
  emits: ['input', 'search', 'show-search'],
  methods: {
    handleSearchKeydown(event) {
      if (event.key === 'Enter') {
        this.$emit('search');
      }
    },

    handleShowSearch() {
      if (this.$root.isMobile) {
        this.$emit('show-search');
      }
    },

    updateSearch(value) {
      this.localSearch = value;
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.team-search-bar {
  border: 1px solid $color-black-4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $color-white;
  box-shadow: $elevation-deth-4;
  height: 48px;
  padding: 4px 4px 4px 16px;
  border-radius: 999px;
  margin-bottom: 32px;
  cursor: pointer;

  @media (min-width: breakpoint(md)) {
    padding: 12px 20px;
    height: 80px;
    border-radius: 8px;
    margin-bottom: 64px;
    cursor: default;
  }

  &__mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  &__text {
    font-size: 14px;
    line-height: 22px;
    color: $color-black-85;
    font-weight: 600;
  }

  &__icon {
    background-color: var(--color-primary, #FF8233);
    border-radius: 999px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-white;
  }

  &__clear {
    margin-left: 8px;
  }

  &__desktop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  &__field {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__label {
    font-size: 14px;
    line-height: 22px;
    color: $color-black;
  }

  &__input {
    ::v-deep .rr-input_md {
      padding: 0;
    }
  }

  &__action {
    ::v-deep .rr-button {
      border-radius: 4px;
    }
  }
}
</style>
